module.exports = __webpack_public_path__ + "static/media/cdap_loggedin.f41fb85f.svg";